<template>
	<div class="main_page error_page">
		<div class="error_page_content">
			<p>Something</p>
			<p>went <span>wrong</span></p>
			<el-button round class="back_btn" @click="back_home">返回首页</el-button>
		</div>
	</div>
</template>

<script>
	export default {
	  name: 'Error',
	  data () {
	    return {
			
	    }
	  },
	  methods:{
		   back_home:function(){
		   		this.$router.replace("/")
		   }
	  }
	 
	}
</script>

<style scoped="scoped">
	.error_page{
		position: relative;
		background-image: url(https://static.wixstatic.com/media/a36401_4635bf0cb41f4f1f9cbf65f56e592e95~mv2_d_7025_3011_s_4_2.jpg/v1/fill/w_1920,h_823,al_c,q_85,usm_0.66_1.00_0.01/a36401_4635bf0cb41f4f1f9cbf65f56e592e95~mv2_d_7025_3011_s_4_2.webp);
		background-repeat: no-repeat;
		background-size: cover;
		background-position: 0 0;
		position: relative;
		width: 100%;
	}
	.error_page_content{
		width: 1024px;
		margin: 0 auto;
		padding-top:140px;
		padding-bottom:120px;
	}
	.error_page_content p{
		height: 100px;
		line-height: 100px;
		margin-top:30px;
		font-size: 100px;
		color:#fff;
	}
	.error_page_content p span{
		color:#FF2828;
	}
	.back_btn{
		width: 80px;
		height: 30px;
		margin-top:50px;
		background-color: unset;
		font-size: 12px;
		color: #fff;
		border: 1px #fff solid;
		padding: 0;
		margin-left: 200px;
	}
	.back_btn:hover{
		background-color: #fff;
		color:#000;
	}
</style>



// WEBPACK FOOTER //
// src/views/public/Error.vue